import React, { useState, useEffect } from 'react';
import { USBCheckbox, USBButton } from '@usb-shield/components-react/dist/cjs';
import { USBInput } from '../../components/shared/USBInputCompat';
import USBDatePicker from '@usb-shield/react-date-picker';
import axios from "axios";
import { getDocumentmgmtServiceURL } from '../../config/connections';

import Messages from '../../components/organisms/Messages/Messages';
import moment from 'moment';
import { getAllUserData } from '../../shared/api/entitlementService'

export default function AdHocEnrollmentForm(props) {

    const defaultDatePickerErrorMessages = {
        default: 'Please enter a valid date.',
        118: 'Please enter a valid date.',
        201: 'Please enter a valid date.',
        202: 'Date should be in the past.',
        203: 'Date should be in the future.',
        221: 'Enter no more than 10 characters.',
        213: 'Enter numbers only.',
        224: '(Optional field)',
        228: "That date isn't available. Please try again.",
    }

    const defaultCalendarSettings = { occurrence: 'past', areBankHolidaysDisabled: false, areWeekendsDisabled: false, numberOfYearsToShow: '10' }
    const [initialProfileData, setInitialProfileData] = useState({ profileID: "", userID: "" });
    const [enrollmentDetails, setEnrollmentDetails] = useState({
        firstName: '',
        lastName: '',
        date: {
            dateInput: {
                initValue: '', inputName: 'Date Added', minimumAge: 0,
                maximumAge: 10,
            }, calendar: { ...defaultCalendarSettings, occurrence: 'past' },
        },
        verifiedBy: ''
    })
    const [isSubmittedAlready, setIsSubmittedAlready] = useState(false);
    const [successFlag, setSuccessFlag] = useState(false);
    const [failedFlag, setFailedFlag] = useState(false);
    const [messageContent, setMessageContent] = useState('');
    const [adHocChecked, setAdHocChecked] = useState(false);

    const getExistingPermission = async (userId) => {
        try {
            const userData = await getAllUserData(userId);
            if (userData) {
                const adHocEnrollmentDetails = userData.data?.adHocEnrollmentDetails;
                console.log(adHocEnrollmentDetails)
                if (adHocEnrollmentDetails) {
                    setEnrollmentDetails({
                        firstName: adHocEnrollmentDetails?.firstName || '',
                        lastName: adHocEnrollmentDetails.lastName || '',
                        date: {
                            dateInput: {
                                initValue: adHocEnrollmentDetails.dateAdded || '',
                                inputName: 'Date Added',
                                minimumAge: 0,
                                maximumAge: 10,
                            },
                            calendar: { ...defaultCalendarSettings, occurrence: 'past' },
                        },
                        verifiedBy: adHocEnrollmentDetails.verifiedBy || ''
                    });
                    setAdHocChecked(adHocEnrollmentDetails.adHocEnrolledFlag);
                    setIsSubmittedAlready(true);
                } else {
                    setEnrollmentDetails({
                        firstName: '',
                        lastName: '',
                        date: {
                            dateInput: {
                                initValue: '',
                                inputName: 'Date Added',
                                minimumAge: 0,
                                maximumAge: 10,
                            },
                            calendar: { ...defaultCalendarSettings, occurrence: 'past' },
                        },
                        verifiedBy: ''
                    });
                    setIsSubmittedAlready(false);
                }
            } else {
                setEnrollmentDetails({
                    firstName: '',
                    lastName: '',
                    date: {
                        dateInput: {
                            initValue: '',
                            inputName: 'Date Added',
                            minimumAge: 0,
                            maximumAge: 10,
                        },
                        calendar: { ...defaultCalendarSettings, occurrence: 'past' },
                    },
                    verifiedBy: ''
                });
                setIsSubmittedAlready(false);
            }
        } catch (e) {
            console.log('DC651:', e);
        }
    }

    function submitAdHocDetails(e) {
        let emptyFields = [];
        if (enrollmentDetails.firstName.trim() === '') {
            emptyFields.push('Name of Person Contacted');
        }
        if (enrollmentDetails.date.dateInput.initValue.trim() === '') {
            emptyFields.push('Verified Date');
        }
        if (enrollmentDetails.verifiedBy.trim() === '') {
            emptyFields.push('Verification Performed By');
        }
        if (emptyFields.length > 0) {
            setMessageContent(`Please fill in the following fields: ${emptyFields.join(', ')}`);
            setFailedFlag(true);
            return;
        }

        let entitlementsUpdate = {
            url: '',
            body: null
        };
        entitlementsUpdate.url = getDocumentmgmtServiceURL({
            service: 'updateProfilePermission',
            userid: `${initialProfileData.userID}`
        });
        entitlementsUpdate.body = {
            "profileId": initialProfileData.profileID,
            "source": "CDC",
            "userId": initialProfileData.userID,
            "adHocEnrollmentDetails": {
                adHocEnrolledFlag: adHocChecked,
                firstName: enrollmentDetails.firstName,
                lastName: enrollmentDetails.lastName,
                dateAdded: enrollmentDetails.date.dateInput.initValue,
                verifiedBy: enrollmentDetails.verifiedBy
            }
        }

        axios.put(entitlementsUpdate.url, entitlementsUpdate.body, { cdcType: "docmanagement" })
            .then((res) => {
                if (res.status === 200) {
                    setIsSubmittedAlready(true);
                    setFailedFlag(false);
                    setSuccessFlag(true);
                    setMessageContent("Ad Hoc Enrollment details submitted successfully.");
                    setTimeout(() => {
                        closeMessage()
                    }, 5000);
                } else {
                    console.error('Error submitting Ad Hoc Enrollment details:', res);
                }
            })
            .catch((error) => {
                setIsSubmittedAlready(false);
                console.error('Error submitting Ad Hoc Enrollment details:', error);
            });
    }

    const closeMessage = () => {
        setFailedFlag(false);
        setSuccessFlag(false);
    };

    useEffect(() => {
        setInitialProfileData(props?.initialProfileData);
        getExistingPermission(props?.initialProfileData?.userID);
    }, [])

    return (
        <>
            {successFlag || failedFlag ? (
                <div
                    className="message-content"
                    data-testid="messageContent"
                    role="alert"
                >
                    <Messages
                        success={successFlag}
                        closeMessage={closeMessage}
                        singleUploadFail={failedFlag}
                        messageContent={messageContent}
                        setFailedFlag={setFailedFlag}
                        setSuccessFlag={setSuccessFlag}
                    />
                </div>
            ) : (
                ''
            )}
            <div className='ad-hoc-enrollment-form'>
                <div style={isSubmittedAlready ? {
                    pointerEvents: 'none',
                    cursor: 'not-allowed',
                    opacity: 0.5,
                } : {}}>
                    <USBCheckbox
                        id="checkAdHocEnrollmentParentDiv"
                        labelText="Ad Hoc Enrollment"
                        subLabel=""
                        checkboxID="checkAdHocEnrollment"
                        handleChange={(e) => {
                            setAdHocChecked(e.target.checked);
                        }}
                        initIsChecked={adHocChecked}

                    />
                </div>
                <div>
                    <USBInput
                        id={'userFirstName'}
                        initValue={enrollmentDetails.firstName}
                        handleChange={(e) => {
                            const value = e.target.value.trim();
                            const [firstName, lastName] = value.split(' ');
                            setEnrollmentDetails(prevState => ({
                                ...prevState,
                                firstName: firstName || '',
                                lastName: lastName ? lastName : prevState.lastName
                            }))
                        }}
                        labelText="Name of Person Contacted"
                        name="firstName"
                        value={enrollmentDetails.firstName}
                        type="text"
                        isReadOnly={isSubmittedAlready}
                        isRequired
                    />

                </div>
                <div>

                </div>

                <div style={isSubmittedAlready ? {
                    pointerEvents: 'none',
                    cursor: 'not-allowed',
                    opacity: 0.5,
                } : {}}>
                    <USBDatePicker
                        dynamicInputValue={enrollmentDetails.date.dateInput.initValue}
                        statusUpdateCallback={(e) => {
                            setEnrollmentDetails(prevState => ({
                                ...prevState,
                                date: {
                                    ...prevState.date,
                                    dateInput: {
                                        ...prevState.date.dateInput,
                                        initValue: e.inputValue
                                    }
                                }
                            }))
                        }}
                        content={{
                            dateInput: {
                                labelText: "Verified Date",
                                errorMessages: { ...defaultDatePickerErrorMessages }
                            },
                        }}
                        settings={enrollmentDetails.date}
                    />
                </div>

                <div>
                    <USBInput
                        id={'verifiedBy'}
                        initValue={enrollmentDetails.verifiedBy}
                        handleChange={(e) => {
                            setEnrollmentDetails(prevState => ({
                                ...prevState,
                                verifiedBy: e.target.value.trim()
                            }))
                        }}
                        labelText="Verification Performed By"
                        name="verifiedBy"
                        value={enrollmentDetails.verifiedBy}
                        type="text"
                        isRequired
                        isReadOnly={isSubmittedAlready} />
                </div>
                <div>
                    <USBButton
                        id="submitAdHocEnrollment"
                        labelText="Submit"
                        type="button"
                        variant="primary"
                        addClasses="sp-button-spacing"
                        handleClick={submitAdHocDetails}
                        disabled={isSubmittedAlready || (enrollmentDetails.date.dateInput.initValue !== '' && !(moment(enrollmentDetails.date.dateInput.initValue).isSameOrBefore(moment().format('YYYY-MM-DD'))))}
                    >Submit</USBButton>
                </div>
            </div>
        </>
    )
}